var render = function render(_c,_vm){return _c('ul',{staticClass:"page-tabs",class:{ 'sidebar-collapsed': _vm.props.sidebarCollapsed }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }